import { ChevronLeft, ChevronRight, LayoutGrid } from 'lucide-react';
import { Button } from '@/design-system';
import type { Highlight } from '@/domain/presentation/contracts';

export interface HighlightNavigatorProps {
  active: Highlight | null;
  hasHighlights: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onOverview: () => void;
}

/** SPEC-011 §48/§56/plan §17/§24/§27 — Previous/Next stepping plus an explicit Overview reset. */
export function HighlightNavigator({
  active,
  hasHighlights,
  onPrevious,
  onNext,
  onOverview,
}: HighlightNavigatorProps) {
  if (!hasHighlights) return null;
  return (
    <div className="flex items-center gap-2 rounded-md border border-border-subtle bg-surface-2 px-2 py-1">
      <Button variant="secondary" aria-label="Destaque anterior" onClick={onPrevious}>
        <ChevronLeft size={14} />
      </Button>
      <span className="min-w-[100px] text-center text-xs text-text-secondary">
        {active ? active.label : 'Visão geral'}
      </span>
      <Button variant="secondary" aria-label="Próximo destaque" onClick={onNext}>
        <ChevronRight size={14} />
      </Button>
      <Button variant="secondary" aria-label="Visão geral" onClick={onOverview}>
        <LayoutGrid size={14} />
      </Button>
    </div>
  );
}
